import React, { useContext } from 'react';

import TrackingContext from '../contexts/TrackingContext';

type EventTrackingSectionProps = {
  section: string;
};

const EventTrackingSection: React.FC<EventTrackingSectionProps> = ({
  section,
  children,
}) => {
  const trackingContext = useContext(TrackingContext);

  if (
    !trackingContext.pageGroup ||
    !trackingContext.page ||
    !trackingContext.applicationName
  ) {
    throw new Error(
      `<EventTrackingSection section="${section}"> must be used within a <EventTrackingPage> component`,
    );
  }

  return (
    <TrackingContext.Provider value={{ ...trackingContext, section }}>
      {children}
    </TrackingContext.Provider>
  );
};

export default EventTrackingSection;
